import React from 'react';
import './App.css';
import PoetryEditor from './PoetryEditor';

function App() {
  return (
    <div className="App">
      <PoetryEditor />
    </div>
  );
}

export default App;
